module.exports = __webpack_public_path__ + "static/media/11d.1aba0804.png";